import { List } from '@hai/ui-react';
import React, { useEffect } from 'react';
//import { useTranslation } from 'react-i18next';
import { SortDirection, SortManager } from 'src/js/component/sort-manager';
import { scrollPanelIntoView } from 'src/js/component/actionBar/streaming-action-bar';
import { constant } from 'src/js/constant';

import { VideoEncoderViewModel } from './video-encoder-models';
import { VidencRow } from './video-encoder-row';

interface Props {
  list: VideoEncoderViewModel[];
  direction: SortDirection;
  sorting: string;
  onSelect: (item: VideoEncoderViewModel, selected: boolean) => void;
  sortInfo: any;
  scrollToId: any;
}

export const VidencList: React.FunctionComponent<Props> = ({
  list,
  direction,
  sorting,
  onSelect,
  sortInfo,
  scrollToId,
}) => {
  useEffect(() => {
    scrollPanelIntoView({ id: scrollToId });
  }, []);

  return (
    <>
      <List accentColor={constant.productColor} removeMediaQueries>
        <SortManager sortInfo={sortInfo} list={list} sortKey={sorting} direction={direction} secondLevelSortKey="name">
          {list &&
            list.map((videnc) => {
              return <VidencRow key={videnc.id} model={videnc} onSelect={onSelect} scrollToId={scrollToId} />;
            })}
        </SortManager>
      </List>
    </>
  );
};
